import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Core version + navigation, pagination modules
import Swiper, { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode ,Controller,EffectFade, EffectCube, EffectCreative,Mousewheel } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-cards';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode,Controller,EffectFade, EffectCube, EffectCreative,Mousewheel]);

// Export for global use if needed
window.Swiper = Swiper

// Full page JS
import fullpage from 'fullpage.js';
import 'fullpage.js/dist/fullpage.css';

// Image comparison slider
import 'img-comparison-slider';

// PURE COUNTER
import PureCounter from "@srexi/purecounterjs";
window.PureCounter = PureCounter

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    new fullpage('#fullpage', {
        responsiveWidth: 1280,
        autoScrolling: true,
        scrollHorizontally: true,
        navigation: true,
        navigationPosition: 'left',
        showActiveTooltip: false,
        navigationTooltips: [],
        anchors: ['hero', 'about', 'serviceCategories', 'portfolios','objects','contact','blog'],

        afterRender: function() {
            const totalSections = document.querySelectorAll('.section').length;
            const navUl = document.querySelector('#fp-nav ul');

            // تنظیم تعداد کل صفحات در متغیر CSS
            navUl.style.setProperty('--total-pages', `"${totalSections}"`);
            // تنظیم صفحه اول در متغیر CSS
            navUl.style.setProperty('--current-page', `"1"`);
        },

        // زمانی که کاربر به یک سکشن دیگر اسکرول می‌کند
        onLeave: function(origin, destination, direction) {
            const navUl = document.querySelector('#fp-nav ul');

            // آپدیت کردن شماره صفحه فعلی
            navUl.style.setProperty('--current-page', `"${destination.index + 1}"`);
        }

    });

    const AUTOPLAY_DELAY = 4000;
    const timerFill = document.getElementById('autoplayTimerFill');

    const heroSwiper = new Swiper('#heroSwiper', {
        modules: [Autoplay, EffectFade],
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 800,
        effect: 'fade',
        autoplay: {
            delay: AUTOPLAY_DELAY,
            disableOnInteraction: false,
        },
    });

    const updateTimer = (timeLeft) => {
        if (!timerFill) return;
        const percent = 100 - Math.max(0, Math.min(100, (timeLeft / AUTOPLAY_DELAY) * 100));
        timerFill.style.width = `${percent}%`;
    };

    heroSwiper.on('autoplayTimeLeft', (swiper, timeLeft) => {
        updateTimer(timeLeft);
    });

    heroSwiper.on('slideChange', () => {
        if (heroSwiper.autoplay.running) {
            timerFill.style.width = '100%'; // ریست به حالت کامل در شروع هر اسلاید
        }
    });

    if (heroSwiper.autoplay.running) {
        timerFill.style.width = '100%';
    }



    const aboutTabSwiper = new Swiper('#aboutTabSwiper', {
        modules: [Thumbs,Autoplay],
        slidesPerView: 4,
        spaceBetween:0,
        mousewheel: true,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
            400:{
                slidesPerView: 4,
            },
            768:{
                slidesPerView: 4,
            },
            1024:{
                slidesPerView: 4,

            },
            1280:{
                slidesPerView: 4,
                spaceBetween:60,
            },
        },

    });



    let aboutSwiper = null;

    function initAboutSwiper() {
        const isDesktop = window.innerWidth >= 1280;


        if (aboutSwiper !== null) {
            aboutSwiper.destroy(true, true);
        }

        if (isDesktop) {
            aboutSwiper = new Swiper('#aboutSwiper', {
                modules: [Thumbs, Autoplay, EffectCreative],
                direction: 'vertical',
                effect: 'creative',
                spaceBetween: 0,
                loopedSlides: 2,
                creativeEffect: {
                    limitProgress: 2,
                    prev: { translate: [0, '-20%', 0], opacity: 0 },
                    next: { translate: [0, '13%', -100], scale: 0.95, opacity: 1 }
                },
                thumbs: {
                    swiper: aboutTabSwiper,
                    slideThumbActiveClass: 'swiper-slide-thumb-active'
                }
            });
        } else {

            aboutSwiper = new Swiper('#aboutSwiper', {
                modules: [Thumbs, Autoplay],
                direction: 'horizontal',
                effect: 'slide',
                slidesPerView: 1,
                spaceBetween: 15,
                watchSlidesProgress: true,
                thumbs: {
                    swiper: aboutTabSwiper,
                    slideThumbActiveClass: 'swiper-slide-thumb-active'
                }
            });
        }
    }

    aboutTabSwiper.on('click', function () {
        if (typeof aboutTabSwiper.clickedIndex !== 'undefined' && aboutSwiper !== null) {
            aboutSwiper.slideTo(aboutTabSwiper.clickedIndex);
        }
    });



    initAboutSwiper();


    let isCurrentlyDesktop = window.innerWidth >= 1280;

    window.addEventListener('resize', () => {
        const newDesktopState = window.innerWidth >= 1280;
        if (newDesktopState !== isCurrentlyDesktop) {
            isCurrentlyDesktop = newDesktopState;
            initAboutSwiper();
        }
    });






    let portfoliosSwiper1, portfoliosSwiper2, portfoliosSwiper3;

    portfoliosSwiper3 = new Swiper('#portfoliosSwiper3', {
        modules: [Controller],
        slidesPerView: 1,
        spaceBetween: 16,
        watchSlidesProgress: true,

    });

    portfoliosSwiper2 = new Swiper('#portfoliosSwiper2', {
        modules: [Thumbs, Mousewheel],
        direction: window.innerWidth >= 1280 ? 'vertical' : 'horizontal',
        slidesPerView: 4,
        spaceBetween: 16,
        mousewheel: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            480:  { slidesPerView: 4 },
            768:  { slidesPerView: 4 },
            1024: { slidesPerView: 4 },
            1280: { slidesPerView: 5 , spaceBetween: 40 },
        },
    });

    portfoliosSwiper1 = new Swiper("#portfoliosSwiper1", {
        modules: [Thumbs, Controller],
        slidesPerView: 1,
        spaceBetween: 16,
        watchSlidesProgress: true,
        thumbs: {
            swiper: portfoliosSwiper2,
        },
        controller: {
            control: portfoliosSwiper3,
        }
    });

    portfoliosSwiper3.controller.control = [portfoliosSwiper1, portfoliosSwiper2];

    let isVertical = window.innerWidth >= 1280;
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            const newDir = window.innerWidth >= 1280 ? 'vertical' : 'horizontal';
            if (isVertical !== (newDir === 'vertical')) {
                isVertical = newDir === 'vertical';
                portfoliosSwiper2.changeDirection(newDir);
                portfoliosSwiper2.update();
            }
        }, 200);
    });


    const objectSwiper = new Swiper('#objectSwiper', {
        modules: [Pagination],
        slidesPerView: 1.3,
        spaceBetween: 20,
        loop:true,
        breakpoints: {
            480:{
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 1.8,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        pagination: {
            el: "#objectSwiperPagination",
        },

    });




    const blogSwiper = new Swiper('#blogSwiper', {
        modules: [Pagination],
        slidesPerView: 1.5,
        spaceBetween: 20,
        loop:true,
        breakpoints: {
            480:{
                slidesPerView: 1.8,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 2.8,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        pagination: {
            el: "#blogSwiperPagination",
        },
    });

    console.clear()
};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})
